import React from 'react';

const LoadingOverlay = () => {
    return (
        <div className="tw1-fixed tw1-inset-0 tw1-z-50 tw1-flex tw1-items-center tw1-justify-center tw1-bg-black tw1-bg-opacity-40">
            <div className="tw1-flex tw1-flex-col tw1-items-center tw1-gap-4">
                <div className="tw1-w-12 tw1-h-12 tw1-border-4 tw1-border-white tw1-border-t-transparent tw1-rounded-full tw1-animate-spin"></div>
                <p className="tw1-text-white tw1-text-lg tw1-font-medium">Loading...</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;